import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { formatCurrency } from "@/utils";

interface FinancialCardProps {
  purchasePrice: number;
  pointPrice: number;
  paymentTerms: string;
  contractDate?: string;
}

export function FinancialCard({
  purchasePrice,
  pointPrice,
  paymentTerms,
  contractDate
}: FinancialCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Financial Information</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        <div className="grid grid-cols-2 gap-2">
          <span className="font-medium">Purchase Price:</span>
          <span>{formatCurrency(purchasePrice,'en-GB','GBP')}</span>
          <span className="font-medium">Point Price:</span>
          <span>{formatCurrency(pointPrice, 'en-GB', 'EUR')}</span>
          <span className="font-medium">Payment Terms:</span>
          <span>{paymentTerms}</span>
          {contractDate && (
            <>
              <span className="font-medium">Contract Date:</span>
              <span>{new Date(contractDate).toLocaleDateString()}</span>
            </>
          )}
        </div>
      </CardContent>
    </Card>
  );
}